import type { Readable, Writable } from "node:stream";

export const DEFAULT_SOURCE = "jixoai/emergent-thinking";
export const DEFAULT_SKILL = "emergent-thinking";
export const DEFAULT_PACKAGE_SPEC = "emergent-thinking@latest";

export const SETUP_MODES = ["install", "upgrade"] as const;
export const SETUP_RUNNERS = ["auto", "bunx", "npx", "pnpx"] as const;
export const SETUP_SCOPES = ["global", "project"] as const;
export const MANAGED_AGENT_IDS = [
  "amp",
  "claude-code",
  "cline",
  "codex",
  "cursor",
  "firebender",
  "gemini-cli",
  "github-copilot",
  "kimi-cli",
  "opencode",
  "qoder",
  "warp",
] as const;

export type SetupMode = (typeof SETUP_MODES)[number];
export type SetupRunner = (typeof SETUP_RUNNERS)[number];
export type ExternalSetupRunner = Exclude<SetupRunner, "auto">;
export type SetupScope = (typeof SETUP_SCOPES)[number];
export type PackageManager = "bun" | "npm" | "pnpm";
export type ManagedAgentId = (typeof MANAGED_AGENT_IDS)[number];
export type ManagedEntrypointKind =
  | "claude-command"
  | "cline-workflow"
  | "copilot-prompt"
  | "cursor-command"
  | "gemini-command"
  | "markdown-command"
  | "opencode-command"
  | "qoder-command";
export type ManagedPromptKind =
  | "append-block"
  | "cline-rule"
  | "cursor-rule"
  | "firebender-rule";

export type SetupIo = {
  cwd: string;
  env: NodeJS.ProcessEnv;
  stderr: Writable;
  stdin: Readable;
  stdout: Writable;
};

export type SetupOptions = {
  agents: string[] | undefined;
  copy: boolean;
  help: boolean;
  runner: SetupRunner;
  scope: SetupScope;
  skill: string;
  source: string;
  systemPromptAgents: string[] | undefined;
  yes: boolean;
};

export type ExternalInvocation = {
  args: string[];
  command: string;
};

export type ManagedEntrypointTarget = {
  kind: ManagedEntrypointKind;
  path: string;
};

export type ManagedPromptTarget = {
  kind: ManagedPromptKind;
  path: string;
};

export type ManagedAgent = {
  commandTarget?: ManagedEntrypointTarget;
  promptTarget?: ManagedPromptTarget;
  id: ManagedAgentId;
  label: string;
};

export type SetupState = {
  agents: string[];
  commandAgents: ManagedAgentId[];
  packageManager: PackageManager;
  promptAgents: ManagedAgentId[];
  scope: SetupScope;
  skill: string;
  source: string;
  updatedAt: string;
  version: 1;
};
